import React, { FC } from 'react';
import styled from 'styled-components';
import { MessageReplyAdded } from 'api/notifications/meta';
import { UserMessageReply } from 'components/molecules/user-message-reply';
import { Content } from './content';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const RepliedTo = styled(UserMessageReply)`
  margin-right: 30%;
`;

const Reply = styled(Content)`
  --rte-readonly-content-padding: 0 30% 0
    calc(var(--spacing-03) + var(--spacing-01));
`;

export const MessageReplyAddedView: FC<{ meta: MessageReplyAdded }> = ({
  meta: {
    message: { content },
    reply: { content: reply },
  },
}) => {
  return (
    <Container className="message-reply-added-container">
      <RepliedTo content={content} showReplyTo={false} />
      <Reply data={reply} />
    </Container>
  );
};
